import { WorkOrderBid as WorkOrderBidType } from 'vendor-marketplace-shared-library';
import { Chip, Grid, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { formatDollarAmountWithoutDecimal } from '../../utilities/formatters';
import Modal from '../common/Modal';
import React, { useState } from 'react';
import ImageThumbnail from '../common/ImageThumbnail';
import { AttachFile as AttachFileIcon } from '@mui/icons-material';

type WorkOrderBidProps = {
  workOrderBid: WorkOrderBidType;
};

export function WorkOrderBid(props: WorkOrderBidProps) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  return (
    <Grid
      container
      direction={'column'}
      sx={[
        {
          backgroundColor: theme.palette.background.default,
        },
        styles.mainContainer,
      ]}
      spacing={1}
    >
      <Grid item>
        <Typography variant={'h6'}>
          {formatDollarAmountWithoutDecimal(props.workOrderBid.bidCostTotal!)}
        </Typography>
      </Grid>
      <Grid item>
        <Typography>{`Vendor: ${props.workOrderBid.conciergeVendor?.name}`}</Typography>
      </Grid>
      <Grid item>
        <Typography>
          {`Start date: ${
            props.workOrderBid.jobStartDate
              ? dayjs(props.workOrderBid.jobStartDate).format('MM/DD/YYYY')
              : 'No start date'
          }`}
        </Typography>
      </Grid>
      {props.workOrderBid.attachments.length > 0 && (
        <Grid item>
          <Chip
            icon={<AttachFileIcon />}
            size={'small'}
            sx={{ cursor: 'pointer' }}
            onClick={() => setOpen(true)}
            label={`View Attachments (${props.workOrderBid.attachments.length})`}
          />
        </Grid>
      )}
      {open && (
        <Modal title={'Bid attachments'} open={open} setOpen={setOpen}>
          <Grid container>
            <Grid container direction={'row'} columnGap={2} sx={styles.imageContainer}>
              {props.workOrderBid.attachments.map(attachment => (
                <ImageThumbnail key={attachment.id} attachment={attachment} />
              ))}
            </Grid>
          </Grid>
        </Modal>
      )}
    </Grid>
  );
}

const styles = {
  imageContainer: {
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingTop: '10px',
    flex: 1,
    justifyContent: 'flex-start',
  },
  mainContainer: {
    padding: 2,
    borderRadius: 4,
  },
};
